import React from 'react';

import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { ConnectedSpaceInfoProvider } from '~src/spacesPlatform/components/Explorer/helpers/SpaceInfoProvider';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';

import { ConnectedQueryParamUpdateProvider } from '../../../../bootstrap/routerHelpers/QueryParamUpdateProvider';
import { SpaceInfo, SpaceItemForNonEntitySpace } from '../../../../spacesPlatform/state/SpaceInfo';
import { ConnectedAllSiteUsersSpace } from './ConnectedAllSiteUsersSpace';

export interface AllSiteUsersSpaceProviderProps {
  readonly routeLocationPath: string;
  readonly routeLocationSearch: string;
  readonly siteName: string;
  readonly urls: SpacesSiteUrls;
}

interface AllSiteUsersSectionSectionProviderProps extends AllSiteUsersSpaceProviderProps {
  readonly shouldRenderAsSubspace: boolean;
}

const AllSiteUsersSpaceInfo: SpaceInfo = {
  item: SpaceItemForNonEntitySpace,
  spaceType: 'siteusers',
  subspaceName: undefined,
  isKeysetPaginationSpace: FeatureFlags.UserGridInfiniteScrollEnabled
};

const AllSiteUsersSectionProvider: React.FunctionComponent<AllSiteUsersSectionSectionProviderProps> = (props) => {
  return (
    <ConnectedSpaceInfoProvider spaceInfo={AllSiteUsersSpaceInfo}>
      <ConnectedQueryParamUpdateProvider
        routeLocationPath={props.routeLocationPath}
        routeLocationSearch={props.routeLocationSearch}
        shouldUpdateBreadcrumbs={true}
        shouldUpdateContentTypes={false}
        shouldUpdateFilters={true}
        shouldUpdateSort={true}
      >
        <ConnectedAllSiteUsersSpace
          {...props}
          siteName={props.siteName}
          urls={props.urls}/>
      </ConnectedQueryParamUpdateProvider>
    </ConnectedSpaceInfoProvider>
  );
};

export const AllSiteUsersSpaceProvider: React.FunctionComponent<AllSiteUsersSpaceProviderProps> = (props) => {
  return <AllSiteUsersSectionProvider {...props} shouldRenderAsSubspace={false}/>;
};
